// 101:发起方拨打, 102:拨打取消, 103:发起方接通后主动挂断
// 201:接收方拒绝, 202:接收方接通成功, 203:接收方接通失败, 204:接收方_通话主动挂断, 205:接收方忙_挂断
// 301:TRTC异常挂断,
// 401:后台检测没有心跳挂断
// 601:第三方挂断
export const EVENTTYPES = {
  iniCall: 101,
  iniCancel: 102,
  iniHangup: 103,
  recRefuse: 201,
  recAccept: 202,
  recAcceptFail: 203,
  recHangup: 204,
  recBusy: 205,
  notSurport: 206,
  errorTRTC: 301,
  die: 401,
  thirdHangup: 601,
};
export const VIDEOSTATUS = {
  idle: 1,
  dialling: 2,
  ring: 3,
  speaking: 4,
  end: 5,
};
export const FILESTATUS = {
  loading: 0,
  uploadFailed: 1,
  sendFailed: 2,
  sendSuc: 3,
  cancel: 4,
  limit: 5,
};
export const MESSAGETYPES = {
  nav: 3,
  bcard: 9,
  historySys: 10,
  video: 11,
  file: 12,
  feedback: 1000011,
  // 手机音视频邀请
  mobileVideoInvitation: 21,
  // 手机音视频状态
  mobileVideoStatus: 22,
};

export const EVENT_TYPES_CN = {
  102: '拨打取消',
  201: '对方拒绝',
  202: '对方接听成功',
  203: '对方接通失败',
  205: '对方忙',
  301: 'TRTC异常挂断',
  401: '后台检测没有心跳挂断',
};
// 音视频 instant.js
export const SUB_MSGTYPE = 1064;
export const SUB_CMD = {
  CMD_INNER_CREATE_RTC_ROOM_INFO_REQ: 312201,
  CMD_INNER_CREATE_RTC_ROOM_INFO_RSP: 312201,
  CMD_INNER_CREATE_RTC_SESSION_REQ: 312251,
  CMD_INNER_CREATE_RTC_SESSION_RSP: 312251,
  CMD_INNER_GET_RTC_ROOMINFO_REQ: 312202,
  CMD_INNER_GET_RTC_ROOMINFO_RSP: 312202,
  CMD_INNER_RTC_ACTION_REPORT_REQ: 312203,
  CMD_INNER_RTC_ACTION_REPORT_RSP: 312203,
  CMD_INNER_RTC_HEART_BEAT_REQ: 312204,
  CMD_INNER_RTC_HEART_BEAT_RSP: 312204,
  CMD_INNER_RTC_STATUS_REPORT_REQ: 312205,
  CMD_INNER_RTC_STATUS_REPORT_RSP: 312205,
  CMD_INNER_GET_RTC_CONFIG_REQ: 312210,
  CMD_INNER_GET_RTC_CONFIG_RSP: 312210,
  CMD_INNER_SCREEN_SHARE_REQ: 312211,
  CMD_WEB_WAIT_POOL_DEL_REQ: 214001,
  CMD_WEB_WAIT_POOL_DEL_RSP: 214001,
  CMD_INNER_WAIT_POOL_GET_COUNT_REQ: 214004,
  CMD_INNER_WAIT_POOL_GET_COUNT_RSP: 214004,
};
